import PhoneNumberField from './PhoneNumberField'

export {
  formatPhoneNumber,
  getMaxPhoneDigits,
  isValidPhoneNumberValue,
} from './PhoneNumberField'

export default PhoneNumberField
